type DateValue = Date | string;

export const overlapsInterval = (
  slot: { start: DateValue; end: DateValue },
  interval: { start: DateValue; end: DateValue },
): boolean => {
  const slotStart = new Date(slot.start).getTime();
  const slotEnd = new Date(slot.end).getTime();
  const intervalStart = new Date(interval.start).getTime();
  const intervalEnd = new Date(interval.end).getTime();

  return slotStart < intervalEnd && slotEnd > intervalStart;
};
